import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const Email = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('email', {
          required: t('mainReporting:form.mandatory'),
          validate: value => /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/i.test(value) || t('mainReporting:form.email.errors.pattern')
        })}
        type={'email'}
        label={t('mainReporting:form.email.label')}
        placeholder={t('mainReporting:form.email.placeholder')}
        autocomplete="email"
      />
      <InputError error={error} />
    </>
  )
}

export default Email
